import {LOCALE_ID, NgModule} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import {locale} from './localisation';

registerLocaleData(localeNl, locale, localeNlExtra);

@NgModule({
  providers: [
    {provide: LOCALE_ID, useValue: locale},
  ],
})
export class I18nModule {
}
